export default function Tech({ tech }) {
  const className = `tech-${tech}`;
  const tooltipText = tech.replaceAll('-', ' ')
  return (
    <div className={`${className} relative group basetech`}>
      <div className="absolute opacity-0 group-hover:opacity-100 transition cursor-default ease-in-out-1s flex justify-center items-center text-center bg-secgray text-white text-sm px-2 py-1 rounded-md -left-3 -top-4">
        {tooltipText}
      </div>
    </div>
  );
}